<svg
  width="7"
  height="11"
  viewBox="0 0 7 11"
  xmlns="http://www.w3.org/2000/svg">
  <path
    d="M6.73608 6.13547L2.08876 10.7317C1.91761 10.9106 1.7039 11 1.44719 11C1.19048 11 0.97677 10.9105 0.805624 10.7317L0.263897 10.2021C0.0880323 10.028 9.97083e-05 9.81626 9.96865e-05 9.56679C9.96651e-05 9.32205 0.0880073 9.10782 0.263897 8.9243L3.72809 5.49997L0.263747 2.0686C0.0879318 1.89443 -8.14542e-07 1.68272 -8.36353e-07 1.43323C-8.57748e-07 1.18851 0.0879068 0.974208 0.263747 0.790766L0.805523 0.26124C0.981363 0.0870713 1.1953 -1.04497e-07 1.44709 -1.26509e-07C1.69898 -1.4853e-07 1.91287 0.0870713 2.08866 0.26124L6.73608 4.85751C6.91199 5.04107 7 5.25525 7 5.5C7.00003 5.74947 6.91199 5.9613 6.73608 6.13547Z" />
</svg>
